import { render, staticRenderFns } from "./rawProducts.vue?vue&type=template&id=9cb87200&scoped=true"
import script from "./rawProducts.vue?vue&type=script&lang=js"
export * from "./rawProducts.vue?vue&type=script&lang=js"
import style0 from "./rawProducts.vue?vue&type=style&index=0&id=9cb87200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb87200",
  null
  
)

export default component.exports